import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

    //not using "environment.ts" since I don't want to edit it multiple places.  just merge it with the right number. ;-)
    version: string = "Release 5.7.0";

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts